import {
  Flex,
  HStack,
  Heading,
  Image,
  Show,
} from '@chakra-ui/react';
import { HamburgerIcon } from '@chakra-ui/icons';
import SiteHeaderWrapper from './SiteHeaderWrapper';

const FalseSiteHeader = () => {
  return (
    <SiteHeaderWrapper>
      <Show breakpoint="(max-width: 767px)">
        <Flex
          width="100%"
          justifyContent="space-between"
          alignItems="center"
          flexDirection="row"
        >
          <HamburgerIcon color="WHITE" fontSize="36px" />
          <Image
            src="/app/images/site-header-logo.png"
            alt="RS Works Logo"
            height="48px"
          />
          <HamburgerIcon color="ORANGE" fontSize="36px" />
        </Flex>
      </Show>

      <Show breakpoint="(min-width: 768px)">
        <Flex
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          maxWidth="1400px"
          width="100%"
        >
          <HStack>
            <Image
              src="/app/images/site-header-logo.png"
              alt="RS Works Logo"
              height="28px"
              paddingRight="20px"
            />
            <Heading variant="navMenu">My Resumes</Heading>
            <Heading variant="navMenu">Help Center</Heading>
          </HStack>

          <HStack spacing={0}>
            <Heading variant="navMenu" color="ORANGE">
              Download
            </Heading>
            <Heading variant="navMenu" color="ORANGE">
              Save
            </Heading>
          </HStack>
        </Flex>
      </Show>
    </SiteHeaderWrapper>
  );
};

export default FalseSiteHeader;
